export enum EMacaronTemplate {
  CLASSIC = "classic",
  COLOR = "color",
  COLOR_AND_BACKGROUND = "color_and_background",
  COLOR_AND_BORDER = "color_and_border",
}
export type IMacaronTemplate = EMacaronTemplate;
